import { useCanvasUi } from "@/pages/canvas/context/CanvasUiContext";
import { useCallback, useMemo } from "react";

/**
 * Opens the edge context menu — from a right-click (`at`) or anchored below a
 * toolbar element (`anchored`). Both write the shared `edgeContextMenu` state,
 * so the rendered menu is identical either way.
 */
export function useOpenEdgeContextMenu() {
  const { setEdgeContextMenu, reactFlowWrapperRef } = useCanvasUi();

  const at = useCallback(
    (edgeId: string, clientX: number, clientY: number) => {
      const wrapperRect = reactFlowWrapperRef.current?.getBoundingClientRect();
      if (!wrapperRect) return;
      setEdgeContextMenu({
        edgeId,
        screenX: clientX - wrapperRect.left,
        screenY: clientY - wrapperRect.top,
      });
    },
    [reactFlowWrapperRef, setEdgeContextMenu],
  );

  const anchored = useCallback(
    (edgeId: string, anchor: HTMLElement) => {
      const rect = anchor.getBoundingClientRect();
      at(edgeId, rect.left + rect.width / 2, rect.bottom);
    },
    [at],
  );

  return useMemo(() => ({ at, anchored }), [at, anchored]);
}
